/**
 * @description - handle faqs
 *
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 */

const faqs = document.querySelectorAll('.js-faq');

faqs.forEach((faq) => {
    const activeClass = 'c-faqs__header--active';
    faq.addEventListener('click', () => {
        if (faq.classList.contains(activeClass)) {
            faq.classList.remove(activeClass);
        } else {
            faq.classList.add(activeClass);
        }
    });
});
